/**
 * LO QUE VA IMPRESO EN TODA COTIZACIÓN Y NO SALE DE LA BASE.
 *
 * Son los datos legales y comerciales de MEGA, copiados del documento que hoy
 * emite World Office. Viven en un solo sitio para que el día que cambie una
 * cuenta bancaria o un teléfono se cambie aquí y no en tres plantillas.
 */
export const EMPRESA = {
  nombre: 'MEGA DISTRIBUCIONES Y PROYECTOS S.A.S.',
  nit: 'Nit: 901.558.482 - 0',
  regimen: 'Somos Responsable de IVA',
  actividad: 'Actividad Económica ICA 4752 4.50 X 1000',
  direccion: 'Cll 4 6 25 BRR CAMELLON DEL QUINDIO',
  telefono: '3105336906',
  ciudad: 'Cartago',
  correo: 'ingenieria.megaproyectos@gmail.com',
  banco: 'Favor consignar en BANCOLOMBIA Cta Aho #72800003160 y enviar soporte al WhatsApp 302 572 0130',
  condiciones:
    'Para dar inicio a la ejecución del proyecto se requiere un anticipo equivalente al del valor total de la cotización.',
} as const
